import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSpryAuth } from "spry-apps-dropdown";
import LoadingFallback from "../../components/elements/LoadingFallback";
import { consumePostLoginRedirect } from "../../helpers/keycloakAuth";

const KeycloakCallback = () => {
  const auth = useSpryAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (auth.isLoading) {
      return;
    }

    if (!auth.isAuthenticated) {
      if (auth.error) {
        navigate("/login", {
          replace: true,
          state: { error: auth.error.message },
        });
        return;
      }
      navigate("/login", { replace: true });
      return;
    }

    const redirectTo = consumePostLoginRedirect("/");
    navigate(redirectTo, { replace: true });
  }, [auth.isLoading, auth.isAuthenticated, auth.error, navigate]);

  return <LoadingFallback />;
};

export default KeycloakCallback;
